import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { useFormik } from "formik";
import { timelineSchema } from "../../Helper/validationSchemas";

import CustomInput from "../inputs/CustomInput";
import { editTimeline } from "../../store/actions/investment/editTimeline";
import { createTimeline } from "../../store/actions/investment/createTimeline";
import SelectField from "../inputs/SelectField";
import CustomButton from "../Buttons/Button";
import { deleteTimeline } from "../../store/actions/investment/deleteTimeline";
import ConfirmModal from "./ConfirmDeleteModal";

const TimelineModal = ({ timeline, onClose, type }) => {
  const dispatch = useDispatch();

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const handleSubmit = (values, { setSubmitting }) => {
    if (type === "CREATE") {
      dispatch(
        createTimeline({
          payload: {
            title: values?.title,
            status: values?.status?.value,
          },
          cb: () => {
            onClose();
          },
          setSubmitting,
        })
      );
    } else {
      dispatch(
        editTimeline({
          payload: {
            title: values?.title,
            status: values?.status?.value,
          },
          cb: () => {
            onClose();
          },
          id: timeline?.id,
          setSubmitting,
        })
      );
    }
  };
  const form = useFormik({
    initialValues: {
      title: timeline?.title || "",
      status: timeline?.title
        ? { value: timeline?.status, label: timeline?.status }
        : {
            value: "Pending",
            label: "Pending",
          },
    },
    validationSchema: timelineSchema,
    onSubmit: handleSubmit,
  });

  const handleDelete = () => {
    setLoadingDelete(true);
    dispatch(
      deleteTimeline({
        id: timeline?.id,
        cb: () => {
          setLoadingDelete(false);
          onClose();
        },
        failed: () => {
          setLoadingDelete(false);
        },
      })
    );
  };

  return openConfirmModal ? (
    <ConfirmModal
      handleDelete={handleDelete}
      onClose={onClose}
      loading={loadingDelete}
      open={openConfirmModal}
    />
  ) : (
    <div className=" top-0 left-0 w-screen h-screen  z-50 flex justify-center items-center fixed bg-[rgba(19,30,61,0.4)]">
      <div className="relative pt-5 min-h-[370px] w-full max-w-[553px] flex flex-col rounded-[12px] border-[1px] border-[#f2f2f7] bg-white shadow-lg">
        <div className="absolute top-3 right-3 cursor-pointer p-3">
          <img
            onClick={() => {
              onClose();
            }}
            src={"/Assets/close.png"}
            alt="Close"
            className="cursor-pointer w-6 h-6"
          />
        </div>

        <div className="flex-1 flex flex-col justify-between pb-[30px]">
          <div className="py-1 px-[30px]">
            <h2 className=" text-[24px] mb-8">
              {type === "CREATE" ? "Create" : "Update"} Timeline
            </h2>
            <div className="mb-4 lg:mb:0  w-full ">
              <p className="">Title:</p>
              <CustomInput
                id="title"
                width="100%"
                form={form}
                placeholder={"Enter Name"}
                height="16px"
                mt="10"
                mr="10px"
                mb="10px"
                borderRadius={"10px"}
                className="mobile-input-width"
              />
            </div>
            <div className=" mb-4 lg:mb:0  w-full">
              <SelectField
                placeholder="Select Stage"
                id="status"
                form={form}
                options={[
                  {
                    value: "Pending",
                    label: "Pending",
                  },
                  {
                    value: "Completed",
                    label: "Completed",
                  },
                ]}
                sx={{
                  width: "100%",
                  padding: "1px",
                  height: "52px",
                  borderRadius: "10px",
                  marginTop: "1px",
                }}
                className="mobile-select"
              />
            </div>
          </div>

          <div className=" px-[30px] flex justify-between ">
            {type !== "CREATE" ? (
              <CustomButton
                variant="contained"
                customColor="#B42318"
                children={"Delete"}
                width="156px"
                height="45px"
                padding="10px"
                margin="15px 0"
                loading={loadingDelete}
                color="#fff"
                onClick={() => {
                  setOpenConfirmModal(true);
                }}
              />
            ) : (
              <></>
            )}
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children={type === "CREATE" ? "Submit" : "Update"}
              width="156px"
              height="45px"
              padding="10px"
              margin="15px 0"
              loading={form?.isSubmitting}
              color="#fff"
              onClick={() => {
                form.handleSubmit();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineModal;
